// extracted by mini-css-extract-plugin
export default {"container":"registration_container__H4Vt6","wrapper":"registration_wrapper__qUWJ3"};